import { useEffect, useState } from 'react';
import type { SupplierBill } from '../utils/supplierBills';
import { subscribeSupplierBills } from '../utils/supplierBillsService';

export function useSupplierBills(): SupplierBill[] {
  const [bills, setBills] = useState<SupplierBill[]>([]);
  useEffect(() => subscribeSupplierBills(setBills), []);
  return bills;
}
